export default {"src":"/_next/static/media/house_24.b812988c.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};